export const contractIntervalNames = {
  MONTHS: "month(s)",
  WEEKS: "week(s)",
  DAYS: "day(s)",
};

export const DAYS_IN_MONTH = 30;
